import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import logo from '../../relaystream-logo-mini.png';
import projector from '../../images/socialIcons/Videoicon.png';
import facebook from '../../images/socialIcons/FBicon1.png';
import youtube from '../../images/socialIcons/youtubeicon.jpg';
import ustream from '../../images/socialIcons/Ustreamicon.png';
import instagram from '../../images/socialIcons/instagramicon.png';
import twitch from '../../images/socialIcons/twitchicon.png';
import './RelayAnimation.css';

class RelayAnimation extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const currentLocationPath = this.props.location.pathname;
    const { t } = this.props;
    return (
      <div className={'relayAnimation ' + ((currentLocationPath === '/login' || currentLocationPath === '/signup' || currentLocationPath === '/forgot-password') ? 'd-none d-xl-block' : '')}>
        <span className="projector">
          <img className="projector img" src={projector} alt="camera icon" />
        </span>
        <hr className="hrProjection" />
        <div className="socialStroke">
          <img className="fa-twitch img" src={twitch} alt="twitch icon" />
        </div>
        <div className="socialStroke">
          <img className="fa-instagram img" src={instagram} alt="instagram icon" />
        </div>
        <div className="socialStroke">
          <img className="fa-ustream img" src={ustream} alt="ustream icon" />
        </div>
        <div className="socialStroke">
          <img className="fa-youtube img" src={youtube} alt="facebook icon" />
        </div>
        <div className="socialStroke">
          <img className="fa-facebook-f img" src={facebook} alt="facebook icon" />
        </div>
        <div className="relayStroke" />
        <img className="relayStreamLogo--mini img" src={logo} alt="relaystream logo" />

        {/* signup to get started button only visible on homepage */}
        {(currentLocationPath === '/') ?
          <Link to="/signup" className="SignUpBtn">
            <button type="submit" className="mx-auto btn btn-sm btn-rounded btn-outline-secondary btn--wide">{t('SIGN_UP_START')}</button>
          </Link> : 
          null}
      </div>
    );
  }
}

export default withRouter(translate('translations')(RelayAnimation));



// WEBPACK FOOTER //
// ./src/components/RelayAnimation/RelayAnimation.js